"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPricedOptions = exports.getPimCodeComponents = exports.isElectricVehicle = exports.getVehiclesFromOrder = exports.getSimpleVehicles = void 0;
const helpers_1 = require("../helpers");
const mappers_1 = require("../mappers");
const enums_1 = require("../../enums");
const getSimpleVehicles = (vehicle) => {
    return mappers_1.FaunaMapper.deleteFields(vehicle, ['id', 'config', 'inventory', 'status', 'stock', '__typename']);
};
exports.getSimpleVehicles = getSimpleVehicles;
const getVehiclesFromOrder = (order, simplify = false) => {
    if (!order)
        return [];
    const allVehicles = (order === null || order === void 0 ? void 0 : order.offers)
        ? order.offers.reduce((vehicles, calculation) => [
            ...vehicles,
            ...(simplify ? calculation.vehicles.map((v) => (0, exports.getSimpleVehicles)(v)) : calculation.vehicles),
        ], [])
        : [];
    return (0, helpers_1.getUniqueItemsByKey)(allVehicles, 'serialNo');
};
exports.getVehiclesFromOrder = getVehiclesFromOrder;
const isElectricVehicle = (vehicleConfig = null) => {
    var _a, _b, _c;
    return ((_b = (_a = vehicleConfig === null || vehicleConfig === void 0 ? void 0 : vehicleConfig.model) === null || _a === void 0 ? void 0 : _a.fuel) === null || _b === void 0 ? void 0 : _b.type)
        ? ((_c = vehicleConfig.model.fuel.type) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === enums_1.VehicleFuelType.ELECTRIC
        : false;
};
exports.isElectricVehicle = isElectricVehicle;
/**
 * Split the PIM code (SKU) into two components:
 *  - `articleNumber`, which corresponds to a vehicle model
 *  - `options`, which corresponds to a unique, make-specific identifier
 *     for each sales package:
 *       * Daimler: "NO"-code
 *       * Kia: "OCN"-code
 *       * Stellantis: Priced options
 */
const getPimCodeComponents = (pimCode) => {
    const pimCodeComponents = typeof pimCode === 'string' ? pimCode.split(' ') : [''];
    let articleNumber;
    let options;
    if (pimCodeComponents.length === 1) {
        // Some Stellantis sales packages use an empty options string.
        // Thus, only `articleNumber` should be used to identify them.
        articleNumber = pimCodeComponents.pop();
    }
    else {
        options = pimCodeComponents.pop();
        articleNumber = pimCodeComponents.join(' ');
    }
    return {
        articleNumber: articleNumber !== null && articleNumber !== void 0 ? articleNumber : '',
        options: options !== null && options !== void 0 ? options : '',
    };
};
exports.getPimCodeComponents = getPimCodeComponents;
/**
 * Use this method to control what vehicles are using priced options.
 */
const isPricedOptions = (pimCode, make) => {
    // PIM Codes with an empty options string
    // should not count as using priced options.
    const notEmptyOptions = pimCode.trim().includes(' ');
    const makeIsEnabled = [
        // Add more makes here as they start using priced options.
        enums_1.MAKE.Peugeot,
    ].includes(make);
    return notEmptyOptions && makeIsEnabled;
};
exports.isPricedOptions = isPricedOptions;
//# sourceMappingURL=vehicle.js.map